export default "__VITE_ASSET__DAD6yyzA__"